import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomSelect from '../home/collections/CustomSelect';
import {
  areaSection,
  defaultFonts,
  getDefaultFontSizes,
  getThemeData,
  headingElements,
  spaceSection,
} from '../../common/utils/validate';
import { drapcodeIcon } from '../../common/custom/icon-library';
import voca from 'voca';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import CustomLoader from '../common/CustomLoader';
import { object } from 'yup';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
export class OverwriteDefaultUi extends React.Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  getDefaultStylingValues = () => {
    return spaceSection.reduce((acc, style) => {
      areaSection.forEach((side) => {
        acc[`${style}${side}`] = '';
      });
      acc[style] = '';
      return acc;
    }, {});
  };

  getSafeCustomThemeData = (customThemeDataObj) => ({
    themeName: customThemeDataObj.themeName || 'Default',
    defaultFonts: customThemeDataObj.defaultFonts || [],
    colors: customThemeDataObj.colors || {},
    hoverColors: customThemeDataObj.hoverColors || {},
    body: customThemeDataObj.body || {},
  });

  getHeadingDefaults = (headingElements, customThemeDataObj) => {
    return headingElements.reduce((acc, el) => {
      acc[`${el}Font`] = null;
      acc[`${el}Color`] = customThemeDataObj.headingColor;
      acc[`${el}FontSize`] = '';

      return acc;
    }, {});
  };

  mergeCustomThemeWithDefaults = (customThemeProps, defaults, safeCustomThemeDataObj) => {
    return {
      ...Object.keys(defaults).reduce((acc, key) => {
        acc[key] = customThemeProps[key] !== undefined ? customThemeProps[key] : defaults[key];
        return acc;
      }, {}),
      themeName: customThemeProps.themeName || safeCustomThemeDataObj.themeName,
      defaultFontsOfTheme: safeCustomThemeDataObj.defaultFonts,
      colors: customThemeProps.colors || safeCustomThemeDataObj.colors,
      hoverColors: customThemeProps.hoverColors || safeCustomThemeDataObj.hoverColors,
      body: customThemeProps.body || safeCustomThemeDataObj.body,
      bodyFont: customThemeProps.bodyFont,
    };
  };

  getInitialValues = (resetDefault = false) => {
    const { onBoarding, appSetting } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) return '';
    const customThemeProps = projectDetail.customThemeProps || {};
    const { globalTheme = [] } = onBoarding;

    const customTheme = globalTheme.find((el) => el.customType === 'GLOBAL_THEME');
    const globalThemeName = customTheme ? customTheme.globalThemeName : 'Default';

    const { customThemeDataObj = {} } = getThemeData(globalThemeName) || {};
    const safeCustomThemeDataObj = this.getSafeCustomThemeData(customThemeDataObj);
    const headingDefaults = this.getHeadingDefaults(headingElements, customThemeDataObj);
    const defaultStylingValues = this.getDefaultStylingValues();

    if (resetDefault === true || globalThemeName !== customThemeProps.themeName) {
      return {
        ...headingDefaults,
        ...defaultStylingValues,
        themeName: safeCustomThemeDataObj.themeName,
        defaultFontsOfTheme: safeCustomThemeDataObj.defaultFonts,
        colors: safeCustomThemeDataObj.colors,
        hoverColors: safeCustomThemeDataObj.hoverColors,
        body: safeCustomThemeDataObj.body,
        // bodyFont: { label: '', value: '' },
      };
    } else {
      return this.mergeCustomThemeWithDefaults(
        customThemeProps,
        {
          ...headingDefaults,
          ...defaultStylingValues,
        },
        safeCustomThemeDataObj,
      );
    }
  };

  renderColorsSection = (values, handleChange) => {
    if (!values || !values.colors) return null;

    const filteredColors = Object.keys(values.colors).filter((color) => color !== 'linkHover');

    return filteredColors.map((color) => (
      <div key={color} className="form-group row align-items-center">
        <label className="col-sm-4 col-form-label">{`btn-${color}:`}</label>
        <div className="col-sm-8 d-flex align-items-center">
          <Field
            name={`colors.${color}`}
            render={({ field }) => (
              <input
                {...field}
                type="color"
                value={values.colors[color]}
                onChange={handleChange}
                style={{
                  width: '40px',
                  height: '40px',
                  border: 'none',
                  background: 'none',
                  marginRight: '10px',
                }}
              />
            )}
          />
          <Field
            name={`colors.${color}`}
            type="text"
            className="form-control"
            style={{ width: '150px' }}
          />
        </div>
      </div>
    ));
  };

  renderHoverColorsSection = (values, handleChange) => {
    if (!values || !values.hoverColors) return null;

    return Object.keys(values.hoverColors).map((color) => (
      <div key={color} className="form-group row align-items-center">
        <label className="col-sm-4 col-form-label">{`btn-${color}:`}</label>
        <div className="col-sm-8 d-flex align-items-center">
          <Field
            name={`hoverColors.${color}`}
            render={({ field }) => (
              <input
                {...field}
                type="color"
                value={values.hoverColors[color]}
                onChange={handleChange}
                style={{
                  width: '40px',
                  height: '40px',
                  border: 'none',
                  background: 'none',
                  marginRight: '10px',
                }}
              />
            )}
          />
          <Field
            name={`hoverColors.${color}`}
            type="text"
            className="form-control"
            style={{ width: '150px' }}
          />
        </div>
      </div>
    ));
  };

  renderBodySection = (values, handleChange) => {
    if (!values || !values.body) return null;

    return Object.keys(values.body).map((item) => (
      <div key={item} className="form-group row align-items-center">
        <label className="col-sm-4 col-form-label">
          {voca.replaceAll(item, '_', ' ') === 'color'
            ? 'text:'
            : voca.replaceAll(item, '_', ' ') === 'backgroundColor'
            ? 'background:'
            : voca.replaceAll(item, '_', ' ') === 'anchorHover'
            ? 'link(hover):'
            : voca.replaceAll(item, '_', ' ') === 'anchor'
            ? 'link:'
            : voca.replaceAll(item, '_', ' ')}
        </label>
        <div className="col-sm-8 d-flex align-items-center">
          <Field
            name={`body.${item}`}
            render={({ field }) => (
              <input
                {...field}
                type="color"
                value={values.body[item]}
                onChange={handleChange}
                style={{
                  width: '40px',
                  height: '40px',
                  border: 'none',
                  background: 'none',
                  marginRight: '10px',
                }}
              />
            )}
          />
          <Field
            name={`body.${item}`}
            type="text"
            className="form-control"
            style={{ width: '150px' }}
          />
        </div>
      </div>
    ));
  };

  renderFontSection = (values, handleChange, setFieldValue, setFieldTouched) => {
    const { onBoarding } = this.props;
    const { customFontsList = [] } = onBoarding;
    let fontOptions = [];
    fontOptions =
      customFontsList &&
      customFontsList.map((font) => ({
        label: font.family,
        value: font.family,
      }));
    const defaultFontOptions = defaultFonts.map((ft) => ({
      label: ft.name,
      value: ft.value,
    }));
    fontOptions = [...fontOptions, ...defaultFontOptions];

    return (
      <div className="mb-5 row container">
        <div className="col-sm-6 col-xs-12 pl-0">{this.renderBodySection(values, handleChange)}</div>
        <div className="col-sm-6 col-xs-12 pl-0">
          <FormFieldWithLabel
            cta={false}
            label="Font"
            icon="select"
            infoIcon={true}
            infoDescription="Select a body font for your project."
          >
            <CustomSelect
              name="bodyFont"
              isMulti={false}
              value={values.bodyFont}
              options={fontOptions}
              onChange={setFieldValue}
              onChangeValue={this.handleChange}
              onBlur={() => setFieldTouched('bodyFont', true)}
              placeholder="Select a body font"
            />
            <ErrorMessage name="bodyFont">
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </FormFieldWithLabel>
        </div>
      </div>
    );
  };

  renderSectionForHeadings = (values, handleChange, setFieldValue, setFieldTouched) => {
    const { onBoarding } = this.props;
    const { customFontsList = [] } = onBoarding;
    let fontOptions = [];
    fontOptions =
      customFontsList &&
      customFontsList.map((font) => ({
        label: font.family,
        value: font.family,
      }));

    const defaultFontOptions = defaultFonts.map((ft) => ({
      label: ft.name,
      value: ft.value,
    }));

    fontOptions = [...fontOptions, ...defaultFontOptions];

    return (
      <div className="mb-5">
        {headingElements.map((el) => (
          <div className="row mb-3 ml-5" key={el}>
            <div className="col-sm-1 d-flex align-items-center p-0">
              <h5 className="font-weight-bold">{el}:</h5>
            </div>
            <div className="col-sm-5">
              <FormFieldWithLabel
                cta={false}
                label="Font"
                icon="select"
                infoDescription="Select a Heading font for your project."
              >
                <CustomSelect
                  name={`${el}Font`}
                  isMulti={false}
                  value={values[`${el}Font`]}
                  options={fontOptions}
                  onChange={setFieldValue}
                  onBlur={() => setFieldTouched(`${el}Font`, true)}
                  placeholder="Select a heading font"
                />
                <ErrorMessage name={`${el}Font`}>
                  {(msg) => <p className="text-error">{msg}</p>}
                </ErrorMessage>
              </FormFieldWithLabel>
            </div>
            <div className="col-sm-3 d-flex align-items-center">
              <label className="mr-2" htmlFor={`${el}Color`}>
                Color:
              </label>
              <Field
                name={`${el}Color`}
                render={({ field }) => (
                  <>
                    <input
                      {...field}
                      type="color"
                      value={values[`${el}Color`]}
                      onChange={(e) => {
                        setFieldValue(`${el}Color`, e.target.value);
                        setFieldTouched(`${el}Color`, true);
                      }}
                      style={{
                        width: '40px',
                        height: '40px',
                        border: 'none',
                        background: 'none',
                        marginRight: '10px',
                      }}
                    />
                    <input
                      {...field}
                      type="text"
                      value={values[`${el}Color`]}
                      onChange={(e) => {
                        setFieldValue(`${el}Color`, e.target.value);
                        setFieldTouched(`${el}Color`, true);
                      }}
                      placeholder="Hex Code"
                      className="form-control"
                      style={{ width: '100px' }}
                    />
                  </>
                )}
              />
              <ErrorMessage name={`${el}Color`}>
                {(msg) => <p className="text-error">{msg}</p>}
              </ErrorMessage>
            </div>
            <div className="col-sm-3 d-flex align-items-center">
              <label className="mr-2" htmlFor={`${el}FontSize`}>
                Font Size:
              </label>
              <Field
                name={`${el}FontSize`}
                render={({ field }) => (
                  <input
                    {...field}
                    type="text"
                    value={values[`${el}FontSize`]}
                    onChange={(e) => {
                      setFieldValue(`${el}FontSize`, e.target.value);
                      setFieldTouched(`${el}FontSize`, true);
                    }}
                    placeholder="e.g., 32px, 2rem, 100%"
                    className="form-control"
                    style={{ width: '100px' }}
                  />
                )}
              />
              <ErrorMessage name={`${el}FontSize`}>
                {(msg) => <p className="text-error">{msg}</p>}
              </ErrorMessage>
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderSectionForBtnStyle = (values, handleChange, setFieldValue, setFieldTouched) => {
    return (
      <div className="mb-5">
        {spaceSection.map((el) => (
          <div className="row mb-3 ml-5" key={el}>
            <div className="col-sm-2 pl-0 d-flex align-items-center">
              <h5 className="font-weight-bold">{el}:</h5>
            </div>
            {this.renderInputField(
              `${el}Top`,
              values,
              setFieldValue,
              setFieldTouched,
              'Top',
              !!values[el],
            )}
            {this.renderInputField(
              `${el}Bottom`,
              values,
              setFieldValue,
              setFieldTouched,
              'Bottom',
              !!values[el],
            )}
            {this.renderInputField(
              `${el}Left`,
              values,
              setFieldValue,
              setFieldTouched,
              'Left',
              !!values[el],
            )}
            {this.renderInputField(
              `${el}Right`,
              values,
              setFieldValue,
              setFieldTouched,
              'Right',
              !!values[el],
            )}
            {this.renderInputField(`${el}`, values, setFieldValue, setFieldTouched, 'All')}
          </div>
        ))}
      </div>
    );
  };

  renderInputField = (name, values, setFieldValue, setFieldTouched, label, isDisabled = false) => (
    <div className="col-sm-2 d-flex align-items-center">
      <label className="mr-2" htmlFor={name}>
        {label}:
      </label>
      <Field
        render={({ field }) => (
          <input
            {...field}
            type="text"
            value={values[name]}
            onChange={(e) => {
              setFieldValue(name, e.target.value);
              setFieldTouched(name, true);
            }}
            placeholder="e.g., 10px, 2.5rem, 20%"
            className="form-control"
            disabled={isDisabled}
          />
        )}
      />
    </div>
  );

  handleSubmit = async (values, { setSubmitting }) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const submissionValues = {
      ...values,
    };

    try {
      await actions.overwriteDefaultUi({ projectId, version, themeProps: submissionValues });
      toast.success('Added Successfully !', {});
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('Submission Failed');
    } finally {
      setSubmitting(false);
    }
  };

  resetToDefault = async (setValues, setSubmitting) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const defaultValues = this.getInitialValues(true);

    Swal.fire({
      title: 'Are you sure?',
      text: 'This action will reset everything to the default settings!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#757C91',
      confirmButtonText: 'Yes, reset it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setValues(defaultValues);

        try {
          await actions.overwriteDefaultUi({ projectId, version, themeProps: defaultValues });
          toast.success('Reset To Default Successfully!', {});
        } catch (error) {
          console.error('Reset to default error:', error);
          toast.error('Reset Failed');
        } finally {
          setSubmitting(false);
        }

        Swal.fire('Reset!', 'Your settings have been reset to default.', 'success');
      }
    });
  };

  render() {
    const { onBoarding, appSetting } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) return '';
    const { customThemeProps } = projectDetail;
    let customTheme = null;
    if (onBoarding && Array.isArray(onBoarding.globalTheme)) {
      customTheme = onBoarding.globalTheme.find((el) => el && el.customType === 'GLOBAL_THEME');
    }

    let flg = false;
    if (projectDetail && customThemeProps && customTheme && customTheme.globalThemeName) {
      flg = customTheme.globalThemeName === customThemeProps.themeName;
    }

    const { overwriteDefaultUiPending } = appSetting;
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'typographyColours'} projectDetail={projectDetail} />
        {overwriteDefaultUiPending ? (
          <ParentContentCard title={'Colors'} icon={'list'}>
            <div className="text-center">
              <CustomLoader loading={overwriteDefaultUiPending} size="20px" color="#303453" />
            </div>
          </ParentContentCard>
        ) : (
          <Formik
            enableReinitialize={true}
            initialValues={this.getInitialValues(false)}
            onSubmit={this.handleSubmit}
          >
            {({
              values,
              handleChange,
              setFieldValue,
              setFieldTouched,
              setValues,
              resetForm,
              isSubmitting,
              setSubmitting,
            }) => (
              <Form>
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                  <div className="row mx-auto">
                    <ParentContentCard title={'Colors'} icon={'list'}>
                      <div className="d-flex">
                        <div className="container">
                          <h4 class="card-title m-0">
                            Base <hr />
                          </h4>
                          {this.renderColorsSection(values, handleChange)}
                        </div>
                        <div className="container">
                          <h4 class="card-title m-0">
                            Hover
                            <hr />
                          </h4>
                          {this.renderHoverColorsSection(values, handleChange)}
                        </div>
                      </div>
                    </ParentContentCard>
                    <ParentContentCard icon="list" title={'Body'}>
                      {this.renderFontSection(values, handleChange, setFieldValue, setFieldTouched)}
                    </ParentContentCard>
                    <ParentContentCard icon="list" title={'Button Box Model'}>
                      {this.renderSectionForBtnStyle(
                        values,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                      )}
                    </ParentContentCard>
                    <ParentContentCard icon="list" title={'Headings'}>
                      {this.renderSectionForHeadings(
                        values,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                      )}
                    </ParentContentCard>
                  </div>

                  <div className="row mx-auto">
                    <div className="col-md-6">
                      <button
                        type="reset"
                        className="btn btn-default btn-md"
                        onClick={() => resetForm()}
                      >
                        <i className={`wb ${drapcodeIcon('reset')}`}></i>&nbsp;Reset
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-md"
                        onClick={() => this.resetToDefault(setValues, setSubmitting)}
                        disabled={isSubmitting}
                      >
                        <i className={`wb ${drapcodeIcon('reset')}`}></i>&nbsp;Reset To Default
                      </button>
                    </div>
                    <div className="col-md-6 text-right">
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting}
                      >
                        <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;
                        {flg ? 'Update' : 'Save'}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    onBoarding: state.onBoarding,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OverwriteDefaultUi);
